import { defineStore } from "pinia";
import { StoreModule } from "@/constants/store.ts";

type SessionState = {
  deviceId: string;
};
/**
 * @module Device Session Store
 * @description
 * This module provides a Pinia store for managing device session information across the application.
 * It is primarily responsible for generating, storing, and providing a unique device identifier
 *  used for authentication and session tracking.
 *
 * The device ID is a critical part of the application's security infrastructure as it:
 * 1. Helps identify and track individual device sessions
 * 2. Provides a way to associate user actions with specific devices
 *
 * This store uses Pinia's persistence feature to ensure the device ID is preserved across
 * page refreshes and browser sessions, maintaining a consistent identity for the device.
 */
export const useDeviceSessionStore = defineStore(StoreModule.DEVICE_SESSION, {
  state: (): SessionState => ({ deviceId: "" }),
  persist: true,
  actions: {
    setDeviceId(payload: string) {
      this.deviceId = payload;
    },
  },
});
